import React from "react";

import FormNotify from "./FormNotify";
import Modal from "../../../Modal/Modal";

const NotifyGestionnaire = ({ initialClient = null }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        className="btn"
        style={{
          width: "max-content",
          margin: "20px",
        }}
      >
        Notifier les gestionnaires
      </button>

      {open && (
        <Modal>
          <div
            className={`modal`}
            style={{
              zIndex: 10000,
            }}
          >
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">
                  Informations de la notification
                </h2>
                <button className="btn modal__close" onClick={handleClose}>
                  X
                </button>
              </div>
              <div
                className="modal__body"
                style={{
                  padding: "20px",
                }}
              >
                <FormNotify initialClient={initialClient} />
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default NotifyGestionnaire;
